import { getUltheraEvidenceReviews } from '../_data/evidence'

/** 본문 히어로와 홈 카드가 함께 사용하는 제목. */
export const ultheraPriceTitle = ["울쎄라 가격,", "같은 샷이어도", "조건은 달랐어요"] as const

/**
 * 울쎄라 가격 페이지가 사용하는 검수 완료 정적 데이터.
 *
 * 원본: 울쎄라_100자이상_전체_260825.csv
 * 화면 시안: 울쎄라_가격페이지_실데이터_260825.html
 * 집계: 2026-08-25
 */
export const ultheraPriceCorpus = {
  validReviewCount: 13_478,
  excludedRowCount: 8,
  priceCandidateCount: 155,
  priceEvidenceCount: getUltheraEvidenceReviews('price').length,
  sourceCount: 4,
  sourceBadges: ["N", "G", "K", "M"],
  reviewPeriod: "2018.06.08~2026.08.25",
  priceEvidencePeriod: "2023.04.18~2026.07.30",
  countedAt: "2026.08.25",
} as const

export const ultheraPriceTableOfContents = [
  { id: "section-01", title: "59만원이라는 숫자 뒤에, ‘부가세 별도’가 있었어요" },
  { id: "section-02", title: "같은 300샷도, 결제 조건까지 같지는 않았어요" },
  { id: "section-03", title: "팔자만 100샷 해보고, 다음엔 300샷을 골랐어요" },
  { id: "section-04", title: "수면으로 바꿨는데, 추가금은 안 받았대요" },
  { id: "section-05", title: "가격표보다 확실했던 건, 눈앞의 팁과 샷 수였어요" },
  { id: "section-06", title: "600샷에 189만원, 그런데 효과는 못 느꼈어요" },
] as const

export const ultheraPriceSections = [
  {
    id: "section-01",
    number: "01",
    keyword: "울쎄라 가격 이벤트",
    titleLines: ["59만원이라는 숫자 뒤에,", "‘부가세 별도’가 있었어요"],
    body: "첫 시술 할인으로 300샷을 59만 원에 받았다는 후기에는 ‘부가세 별도’가 붙어 있었어요. 다른 사람은 300샷 69만 원 이벤트를 보고 다녀왔다고 했고요. 눈에 먼저 들어오는 가격만 비교하면, 마지막에 낼 금액을 놓칠 수 있겠더라고요.",
    quote: "59만 원(부가세 별도)에 받을 수 있었어요.",
    quoteSource: "구글 지도 · 2026.07",
    evidence: "이벤트 가격을 봤다면, 마지막에 결제할 총액도 함께 물어보세요.",
    variant: "first" as const,
  },
  {
    id: "section-02",
    number: "02",
    keyword: "울쎄라 샷 수",
    titleLines: ["같은 300샷도,", "결제 조건까지 같지는 않았어요"],
    body: "300샷 59만 원 후기에는 첫 시술 할인과 부가세 별도가 적혀 있었어요. 69만 원 후기는 이벤트 방문과 원장 지정 상담을 함께 이야기했고요. 병원과 시기가 다른 경험이라, 샷 수 하나만으로 어느 쪽이 더 싼지 결론 내리지는 않았습니다.",
    quote: "울쎄라 300샷 69만원 이벤트하길래 회사반차내고 다녀왔는데",
    quoteSource: "구글 지도 · 2026.03",
    evidence: "몇 샷인지와 함께 장비 세대·부위·포함 비용을 확인해야 실제 가격을 비교할 수 있어요.",
  },
  {
    id: "section-03",
    number: "03",
    keyword: "울쎄라 시술 부위와 샷 수",
    titleLines: ["팔자만 100샷 해보고,", "다음엔 300샷을 골랐어요"],
    body: "처음에는 팔자주름만 울쎄라 100샷을 받고, 만족해서 다음 방문에는 300샷을 선택했다는 사람이 있었어요. 같은 날 200샷을 추가한 이야기는 아닙니다. 샷 수를 정할 때는 내가 바라는 부위가 어디인지부터 말하는 게 도움이 되겠어요.",
    quote: "저번에 팔자주름만 울쎄라 100샷해봤는데 효과가 좋아서 300샷하러 왔어요!!!",
    quoteSource: "네이버 지도 · 2024.11",
    evidence: "‘몇 샷이 좋아요?’ 전에, 내가 바꾸고 싶은 부위부터 짚어보세요.",
  },
  {
    id: "section-04",
    number: "04",
    keyword: "울쎄라 수면마취 비용",
    titleLines: ["수면으로 바꿨는데,", "추가금은 안 받았대요"],
    body: "연고마취로 시작했다가 너무 아파 수면으로 바꿨는데, 추가 비용을 받지 않았다는 사람이 있었어요. 프라임 400샷에 수면이 무료로 포함됐다는 후기도 있고요. 두 사례가 모든 병원의 규칙은 아니니, 처음부터 포함인지 도중에 바꿔도 같은 조건인지 나눠서 확인해 보세요.",
    quote: "연고마취하다 너무 아파서 수면마취로 중간에 바꿨는데 비용도 더 안받으시고 통증도 없고 만족합니다!",
    quoteSource: "모두닥 · 2023.04",
    evidence: "무료라고 생각하고 갔다가 달라지지 않게, 포함 여부와 추가 금액을 예약 전에 숫자로 확인하세요.",
  },
  {
    id: "section-05",
    number: "05",
    keyword: "울쎄라 정품",
    titleLines: ["가격표보다 확실했던 건,", "눈앞의 팁과 샷 수였어요"],
    body: "정품 팁과 샷 수를 눈앞에서 확인시켜 줘서 믿음이 갔다는 후기가 있었어요. 비싸니까 괜찮겠지 하고 넘어가는 것보다, 내가 받을 시술을 직접 확인하는 과정이 더 구체적인 안심이 됐던 거예요.",
    quote: "정품 팁 확인부터 샷수 체크까지 제 눈앞에서 확실하게 인증해 주시니까",
    quoteSource: "네이버 지도 · 2026.07",
    evidence: "가격으로 정품을 짐작하지 말고, 팁과 샷 수를 어떻게 확인할 수 있는지 물어보세요.",
    variant: "start" as const,
  },
  {
    id: "section-06",
    number: "06",
    keyword: "울쎄라 가격과 결과",
    titleLines: ["600샷에 189만원,", "그런데 효과는 못 느꼈어요"],
    body: "59만 원에 300샷을 받고 일주일 뒤 만족했다고 적은 사람이 있었어요. 반대로 189만 원에 600샷을 받았지만 한 달 뒤에도 효과를 전혀 못 느꼈다는 사람도 있었고요. 두 후기만으로 어느 가격이 낫다고 말할 수는 없지만, 결제액만으로 결과를 예측하기 어렵다는 건 분명했습니다.",
    quote: "울쎄라 600 샷을 189만원에 했는데요\n효과전혀없어서 한달뒤에 병원갔더니",
    quoteSource: "카카오맵 · 2025.12",
    evidence: "샷 수와 결제액이 커도 결과까지 따라오는 건 아니었어요. 왜 이 샷 수가 필요한지부터 설명을 들어보세요.",
  },
] as const

export const ultheraPriceStory = {
  title: "한 사람의 예산 안에서",
  label: "실제 후기 1건",
  beats: [
    { stage: "첫 방문 할인", lines: ["300샷 59만 원,", "부가세는 별도였다."] },
    { stage: "상담실에서", lines: ["600샷을 추천받았지만,", "예산은 한정적이었다."] },
    { stage: "일주일 뒤", lines: ["팔자주름과 볼 탄력에", "만족한다고 적었다."] },
  ],
  quote: "600샷 시술을 추천받았지만 예산이 한정적이라",
  quoteSource: "구글 지도 · 2026.07",
  takeaway: "추천받은 샷 수와 내가 쓸 수 있는 예산을 함께 이야기해 보세요.",
} as const

export const ultheraPriceShotNarratives = [
  {
    eyebrow: "300샷은 어땠어요?",
    title: "59만원과 69만원, 같은 건 샷 수였어요",
    segments: [
      { text: "59만 원", emphasis: true },
      { text: " 후기에는 첫 시술 할인과 부가세 별도가 적혀 있었어요. " },
      { text: "69만 원", emphasis: true },
      { text: " 이벤트 후기는 원장 지정 상담을 함께 이야기했고요. 같은 300샷이지만 포함 조건이 모두 같다고 확인된 비교는 아닙니다." },
    ],
    source: "구글 지도 · 2026.03, 2026.07 · 서로 다른 후기 2건",
  },
  {
    eyebrow: "600샷이면 만족도도 올라갈까요?",
    title: "189만원을 써도, 아쉬움이 남은 사람이 있었어요",
    segments: [
      { text: "600샷에 189만 원", emphasis: true },
      { text: "을 냈지만 한 달 뒤에도 효과가 없다고 느낀 사람이 있었어요. 많이 받았으니 만족할 거라고 단정하기보다, 내 얼굴에 왜 그 샷 수가 필요한지 설명을 들어보면 좋겠어요." },
    ],
    source: "카카오맵 · 2025.12 · 한 사람의 경험",
  },
] as const

export const ultheraPrimeNote = {
  eyebrow: "장비 이름도 확인해 보세요",
  title: "프라임이라는 이름만으로 가격 차이를 설명할 수 있을까요?",
  description: "이번에 남긴 단독 시술 후기만으로 장비별 가격 차이를 비교하지는 않았어요. 프라임이라는 이름 외에도 샷 수와 마취 포함 여부가 적혀 있는지 함께 확인해 보세요. 병원과 시기가 다른 가격을 장비 값의 차이라고 단정하지 않았습니다.",
  href: "https://merz.co.kr/brand/ultherapy-prime/",
  linkLabel: "제조사 울쎄라피 프라임 안내 보기",
} as const

const comparison = (section: typeof ultheraPriceSections[number], items: {title: string; description: string}[], ariaLabel: string) => ({
  ariaLabel, items, quote: section.quote, quoteSource: section.quoteSource, takeaway: section.evidence,
})

export const ultheraPriceComparisons = {
  scope: comparison(ultheraPriceSections[2], [
    { title: "이전 방문 · 팔자 100샷", description: "팔자주름만 울쎄라 100샷을 먼저 받아봤다고 적었어요." },
    { title: "다음 방문 · 300샷", description: "앞선 경험에 만족해 다시 방문했어요. 같은 날 추가한 샷 수는 아닙니다." },
  ], "시술 부위와 재방문 샷 수"),
  anesthesia: comparison(ultheraPriceSections[3], [
    { title: "처음부터 포함", description: "울쎄라피프라임 400샷에 수면이 무료로 포함됐다는 후기예요." },
    { title: "중간에 바꿔도 추가금 없음", description: "연고마취에서 수면으로 바꿨지만 비용을 더 받지 않았다는 경험이에요." },
  ], "수면마취 포함 조건의 개별 경험"),
  authenticity: comparison(ultheraPriceSections[4], [
    { title: "팁 확인", description: "정품 팁을 눈앞에서 확인시켜 줬다고 적었어요." },
    { title: "샷 수 체크", description: "같은 후기에서 샷 수도 직접 확인했다고 했어요. 두 사람의 비교가 아니라 한 사람의 확인 과정입니다." },
  ], "한 사람의 팁과 샷 수 확인"),
  outcome: comparison(ultheraPriceSections[5], [
    { title: "300샷 · 59만원", description: "시술 일주일 뒤 팔자주름과 볼 탄력에 만족한다고 적었어요." },
    { title: "600샷 · 189만원", description: "한 달 뒤에도 효과를 느끼지 못했다고 적었어요." },
  ], "가격과 효과 경험이 달랐던 실제 후기"),
} as const

export const ultheraPriceEvidenceReviews = getUltheraEvidenceReviews('price')
